module.exports = "https://static.energy5.com/_next/static/images/glance-1-ef622a7b2a479a5cce806f2d99efbdeb.png";